import { NotificationRoute } from '/@/modules/notification/constants/NotificationRoute';
import { OpsRoute } from '/@/modules/ops/constants/OpsRoute';

export const router = [
  {
    name: NotificationRoute.NOTIFICATIONS.name,
    path: `/${OpsRoute.OPS}/${NotificationRoute.NOTIFICATIONS.path}`,
    component: () => import('/@/modules/notification/pages/NotificationsPage.vue')
  }
];
